import React from "react";
import Box from "@mui/material/Box";
import cmrLogo from "../../../assets/images/logos/cmr-logo.png";

const CmrDashboardLogo = ({ height, maxWidth, sx }) => (
  <Box
    component="img"
    src={cmrLogo}
    alt="CMR — Continuous Medical Record"
    sx={{
      display: "block",
      height: height ?? "auto",
      width: "auto",
      maxWidth: maxWidth ?? "100%",
      ...sx,
    }}
  />
);

export default CmrDashboardLogo;
